import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSelectAutocompleteComponent } from './input-select-autocomplete.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ErrorsLabelModule } from '../errors-label/errors-label.module';
import { DirectiveModule } from '@/directives/directive.modules';
import { MaterialModule } from 'src/app/shared/material.module';

@NgModule({
  declarations: [InputSelectAutocompleteComponent],
  imports: [
    CommonModule,
    DirectiveModule,
    ErrorsLabelModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
  ],
  exports: [InputSelectAutocompleteComponent],
})
export class InputSelectAutocompleteModule {}
